/**
 * Extrai e formata o número da NFe a partir da chave de acesso
 *
 * @param nfeKey - Chave de acesso da NFe (44 dígitos) ou com prefixo "NFe"
 * @returns Número da NFe formatado (sem zeros à esquerda)
 */
export default function formatNFeNumber(nfeKey: string): string {
  // Retorna vazio se não houver chave
  if (!nfeKey) {
    return "";
  }

  // Remove o prefixo "NFe" se existir
  let cleanKey = nfeKey.replace(/^NFe/i, "");

  // Valida se a chave limpa tem 44 dígitos
  if (cleanKey.length !== 44) {
    return "";
  }

  // Extrai o número da NFe (posições 26-34, índice 25-33)
  const nfeNumber = cleanKey.substring(25, 34);

  // Remove zeros à esquerda
  return parseInt(nfeNumber, 10).toString();
}

/**
 * Extrai informações básicas da chave NFe
 *
 * @param nfeKey - Chave de acesso da NFe (44 dígitos) ou com prefixo "NFe"
 * @returns Objeto com informações da NFe ou null se inválida
 */
export function parseNFeKey(nfeKey: string) {
  if (!nfeKey) {
    return null;
  }

  // Remove o prefixo "NFe" se existir
  let cleanKey = nfeKey.replace(/^NFe/i, "");

  // Valida se a chave limpa tem 44 dígitos
  if (cleanKey.length !== 44) {
    return null;
  }

  return {
    numero: parseInt(cleanKey.substring(25, 34), 10).toString(),
    serie: cleanKey.substring(22, 25),
    chaveCompleta: cleanKey,
  };
}
